<template>
  <div>

    <div class="allContent">

      <div class="top_header">

        <marquee behavior="alternate">
          <strong>
            {{project.itemName}}({{project.itemNum}}) 交易公告竞价会
          </strong>
        </marquee>
      </div>
      <div class="bottom_content">
        <div class="bottom_content_left">
          <div style="width:98%;height:1%"></div>
          <div class="bottom_content_left_top">
            <i class="el-icon-s-management">&nbsp;竞价会概况</i>
          </div>
          <div class="bottom_content_left_bottom">
            <div class="bottom_content_left_bottom_per">
              转让方：<!-- {{project.dataTransferInfo.name}} -->
            </div>
            <div class="bottom_content_left_bottom_per">
              转让方类型：
              <span v-if="project.infoType==1">个人</span>
              <span v-if="project.infoType==2">企业</span>
              <span v-if="project.infoType==3">集体</span>
              <span v-if="project.infoType==4">合作社</span>
            </div>
            <div class="bottom_content_left_bottom_per">
              转让地址：<!-- {{project.dataTransferInfo.address}} -->
            </div>
            <div class="bottom_content_left_bottom_per">
              开始时间：{{project.biddingStartTime}}
            </div>
            <div class="bottom_content_left_bottom_per">
              竞价方式：阶梯竞价
            </div>
            <div class="bottom_content_left_bottom_per">
              起始价：{{project.price}} 元
            </div>
            <div class="bottom_content_left_bottom_per">
              竞价阶梯：{{project.ladderPrice}} 元
            </div>
            <div v-if="project.fuseFlag==1" class="bottom_content_left_bottom_per">
              熔断值：{{project.fusePrice}}元
            </div>

            <div class="bottom_content_left_bottom_per">
              自由报价结束：3分钟
            </div>
            <div class="bottom_content_left_bottom_per">
              延时报价：2分钟
            </div>

            <div  v-if="project.fuseFlag==0"  class="bottom_content_left_bottom_per">
              优先权：无
            </div>






          </div>
        </div>
        <div class="bottom_content_center">
          <div style="width:94%;height:8vh;margin-left:4%;margin-top:3%;">
            <div style="width:57%;height:100%;float:left;color:#fff">
              <div v-if="!flagOver30">
                <div class="center_left_top" id="biddingBar" v-if="!isEndFlag&&!isNotStartFlag">&nbsp;&nbsp;
                  距竞价结束：
                  <span style="font-size: 32px;color:#fff;" v-if="minutes>1"><strong>{{minutes-2}}</strong> </span>
                    <span style="font-size: 32px;color:#fff;"  v-if="minutes==1"><strong>1</strong> </span>
                    <span style="font-size: 32px;color:#fff;"  v-if="minutes<1"><strong>{{minutes}}</strong> </span>
                  分
                  <span style="font-size: 32px;color:#fff;"><strong>{{seconds}}</strong> </span>
                  秒
                </div>
                <div class="center_left_top" v-if="isNotStartFlag">&nbsp;&nbsp;
                  距竞价开始：
                  <span style="font-size: 32px;color:#fff;"><strong>{{minutesNotStart}}</strong> </span>
                  分
                  <span style="font-size: 32px;color:#fff;"><strong>{{secondsNotStart}}</strong> </span>
                  秒
                </div>
              </div>

            </div>
            <div style="width:43%;height:100%;float:left;">
              <div class="jingjia2">
                <el-tag v-if="isYanShiFlag" style="margin-left: 1%;float: left;margin-top:1%;"> <span class="el-icon-alarm-clock"></span>
                  延时报价阶段</el-tag>
                <el-tag type="success" style="margin-right: 1%;float: right;margin-top:1%;"> <span
                    class="el-icon-alarm-clock"></span>竞价周期：3分钟</el-tag>
                   <!-- <el-tag type="primary" style="margin-right: 2%;float: right;margin-top:1%;"> <span
                        class="el-icon-c-scale-to-original"></span>剩余次数：{{10-chuJiaCount}}</el-tag> -->
              </div>
            </div>
          </div>

          <div style="width:93%;height:38vh;margin-left:4%;margin-top:4%;">
            <div class="jingjiaInfo_left_left" v-if="!isNotStartFlag">
              <div class="jingjiaInfo_left_leftContent">
                <span class="el-icon-star-on " style="font-size:24px;color: #f5a623;"></span>
                <span style="font-size: 16px;color:white">
                  <strong>
                    最高 出 价</strong>
                </span>
              </div>
            </div>
            <div class="jingjiaInfo_left_right" v-if="!isNotStartFlag">
              <div class="zuigaochujia" v-if="isTopPricePeople">您是最高出价人</div>
              <div class="zuigaojia">
                <strong style="font-size:60px;color:red">{{topPrice}}</strong> 元
              </div>
            </div>
            <div class="jingjiaInfo_left_right" v-if="isNotStartFlag"
              style="font-size: 26px;margin-top: 100px;color:white">
              <div v-if="!flagOver30">
                距竞价开始时间剩余：
                <span style="font-size: 38px;color:red;"><strong>{{minutesNotStart}}</strong> </span>
                分
                <span style="font-size: 38px;color:red;"><strong>{{secondsNotStart}}</strong> </span>
                秒
              </div>
              <div v-if="flagOver30">
                距竞价开始时间超过30分钟，请等待...
              </div>
            </div>
            <div class="jingjiaInfo_left_right" v-if="isEndFlag&&biddingRecords.length>0"
              style="font-size: 26px;margin-top: 100px;color:white">
              竞价已结束：最高出价人-{{biddingRecords[0].name}}&nbsp;&nbsp;&nbsp;&nbsp;({{biddingRecords[0].price}})

            </div>

          </div>


          <div style="width:96%;height: 24%;color:white;margin-left:2%;text-align:center"
            v-if="!isNotStartFlag&&!isEndFlag">
            <div style="width: 96%;height: auto;overflow:hidden;float: left;margin-top: 1%;text-align:center">
              <div style="width: 34%;height: 60px;float: left;line-height: 60px;font-size: 26px;text-align: center;">
                <strong>加价幅度</strong>
              </div>
              <div
                style="width:60px;height:60px;line-height:60px;;background-color:#949090;color:white;border:1px solid #949090;cursor: pointer;border-radius:5px;float:left;font-size: 26px;text-align:center">
                <img src="../../../assets/jian.png" style="width:70%;height:100%">
              </div>
              <div
                style="height:60px;line-height:60px;;color:white;float:left;font-size: 26px;text-align:center;margin-left:10px">
                +{{ladderPrice}}元（{{parseInt(ladderNumber)-parseInt(project.price/ladderPrice)}}次）
              </div>
              <div @click="jia()"
                style="width:60px;height:60px;line-height:60px;;background-color:#009688;color:white;border:1px solid #009688;cursor: pointer;border-radius:5px;float:left;font-size: 26px;text-align:center">
                <img src="../../../assets/jia.png" style="width:70%;height:70%;margin-top:15%">
              </div>

            </div>

            <div style="width: 96%;height: auto;overflow:hidden;float: left;margin-top: 2%;text-align:center">
              <div style="width: 20%;height: 60px;float: left;line-height: 60px;font-size: 26px;text-align: center;">

              </div>
              <div style="height:60px;line-height:60px;;color:white;float:left;font-size: 26px;text-align:center">
                拟出价：<span style="color:red;font-size:30px">{{ladderPrice*ladderNumber}}<span
                    style="font-size:15px">&nbsp;元</span></span>
              </div>

            </div>
          </div>
          <div style="width:100%;height:80px;text-align:center;" v-if="!isNotStartFlag&&!isEndFlag">
            <el-button type="primary" @click="send()" v-if="(!biddingDisabledFlag&&!isTopPricePeople)&&((project.fuseFlag==1&&project.fusePrice>topPrice)||project.fuseFlag==0)"
              style="height: 70px;font-size: 24px;width:80%;">提交报价</el-button>
            <el-button type="danger" v-if="isTopPricePeople" style="height: 70px;font-size: 24px;width:80%;">您是最高出价人
            </el-button>

            <el-button   type="success" v-if="project.fuseFlag==1&&project.fusePrice<=topPrice"
             style="height: 70px;font-size: 24px;width:80%;margin-top:10px">
            当前最高价已达到熔断值，不能出价
            </el-button>

           <!-- <el-button type="danger" v-if="chuJiaCount==10"
              style="height: 70px;font-size: 24px;width:80%;">您的出价次数已用完</el-button> -->
          </div>



        </div>
        <div class="bottom_content_right">
          <div style="width:98%;height:1%"></div>
          <div class="bottom_content_left_top">
            <i class="el-icon-notebook-2">&nbsp;报价历史记录</i>
          </div>
          <div>

            <div class="center_right_top" v-for="(item,index) in biddingRecords">
              <div class="center_right_per"
                style="width: 40%;text-align:left;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                &nbsp;&nbsp;{{biddingRecords.length-index}}、{{item.userId}}号
              </div>
              <div class="center_right_per" style="width: 25%;">
                {{item.price}} 元
              </div>

              <div class="center_right_per" style="width:30%;">{{item.createTime.substr(11,15)}}</div>

            </div>



          </div>

        </div>

      </div>
    </div>
    <div class="center">


    </div>

  </div>
</template>
<script>
  const timer=null;
  const synth = window.speechSynthesis;
  const msg = new SpeechSynthesisUtterance();
  import Speech from 'speak-tts'
  export default {
    data() {
      return {
        percent: 40,
        ladderPrice: 0,
        biddingPeople: 0, //参与竞价人数
        sendmessage: "",
        message: [],
        userId: localStorage.getItem("userId"),
        minutes: "",
        seconds: "",
        biddingStartTime: "",
        biddingTime: "",
        project: {},
        projectId: localStorage.getItem("projectId"),
        isEndFlag: false,
        isNotStartFlag: true,
        biddingRecords: {},
        biddingRecordDto: {
          "price": 0,
          "transferId": localStorage.getItem("projectId"),
          "userId": localStorage.getItem("userId"),
        },
        minutesNotStart: 0,
        secondsNotStart: 0,
        topPrice: 0,
        isTopPricePeople: false,
        ladderNumber: 1,
        flagOver30: true, //是否超过30分钟
        biddingDisabledFlag: false,
        timerFirst: {},
        timerSecond: {},
        isYanShiFlag: false, //是否为延时报价阶段
        firstYanShiFlag:false,//第一次进入延时标志
        //chuJiaCount:0,//出价次数
        lastLadderNumber:1,
      }
    },
    created() { // 页面创建生命周期函数
      this.initWebSocket();
      this.getPriceRecord();
      clearInterval(this.timerFirst);
this.timerFirst = null
      this.timerFirst = setInterval(this.countTimeFirst, 1000);

    },
   destroyed() { // 离开页面生命周期函数

     clearInterval(this.timerFirst);
     this.timerFirst = null
    // console.log(11111111111111111111111)
      clearInterval(this.timerSecond);
       this.timerSecond = null
    // this.websocketclose();

    },
    methods: {
        jian() {

        if( (this.ladderNumber<=this.lastLadderNumber)){
            this.$message.error("您的竞价低于最新报价，请重新选择")
          return;
        }
         this.ladderNumber = this.ladderNumber - 1;
      },
      jia() {
         if(this.project.fuseFlag==1&&this.project.fusePrice<(this.ladderNumber+1)*this.project.ladderPrice){
          this.$message.error("不能超过熔断值："+this.project.fusePrice)
            return;
         }
        if((this.ladderNumber-this.lastLadderNumber)>10){
            this.$message.error("单次加价幅度不能超过10")
            return;
        }
         this.ladderNumber = this.ladderNumber + 1;
      },

      //获取项目基本信息
      async getProjectInfo() {
        const {
          data: res
        } = await this.$http.get("/web/v1/transfer/" + this.projectId);
        this.project = res.data;

        this.biddingStartTime = res.data.biddingStartTime;
        this.biddingTime = res.data.biddingStartTime;
        this.ladderPrice = res.data.ladderPrice;

        this.ladderNumber = this.project.price / this.ladderPrice;
         this.lastLadderNumber=this.project.price/ this.project.ladderPrice;
      },
      //获取竞价出价记录，如果竞价出价记录没有的话，那么什么也不操作，如果竞价出价记录有的话，那么需要获取最新的一条竞价记录的时间
      async getPriceRecord() {


        const {
          data: res
        } = await this.$http.get("/web/v1/oneBiding/" + this.projectId);
        this.biddingRecords = res.data.recordList;

        if (res.data.recordList.length == 0) {
          this.getProjectInfo();
        } else {
          const {
            data: res1
          } = await this.$http.get("/web/v1/transfer/" + this.projectId);
          this.project = res1.data;
           this.biddingStartTime = res1.data.biddingStartTime;
            this.isYanShiFlag = false;
            this.biddingTime = res.data.recordList[0].createTime;
            console.log( this.biddingTime)

          this.topPrice = res.data.recordList[0].price;
          if (res.data.recordList.length > 0) {
            this.ladderNumber = this.topPrice / this.project.ladderPrice + 1;
            this.lastLadderNumber=this.topPrice / this.project.ladderPrice;
            this.ladderPrice = this.project.ladderPrice;
          }

          if (res.data.recordList[0].userId == this.userId) {
            this.isTopPricePeople = true;
          } else {
            this.isTopPricePeople = false;
          }
          if (this.project.state == 5) {
            //this.countTime();
          }
        }
       // this.judugeBiddingCount();
      },
      // //判断是否超过10次
      // judugeBiddingCount() {
      //   var cishu = 0;
      //   for (var i = 0; i < this.biddingRecords.length; i++) {
      //     if (this.biddingRecords[i].userId == this.userId) {
      //       cishu = cishu + 1;
      //     }

      //   }
      //   if (cishu > 10) {
      //     this.biddingDisabledFlag = true;
      //   } else {
      //     this.biddingDisabledFlag = false;

      //   }
      // },
      countTimeFirst() { //计时器1 第一个报价阶段，3分钟使用
        //获取当前时间
        var date = new Date();
        var now = date.getTime();

        //获取最新报价时间
        var endDate = new Date(this.biddingTime);
        var end = endDate.getTime();
       // console.log(this.biddingTime)
        //获取最新报价和当前时间的时间差
        //lefttime未剩余时间,为获取的时间+3分钟,当达到了剩余时间为0的时候,
        var leftTime = parseInt((end - now) / 1000) + 60 * 5;  /////////////////
        this.minutes = parseInt(leftTime / 60);
        this.seconds = parseInt(leftTime % 60);
          console.log(leftTime)
        if (leftTime > 33 * 60) { //如果竞价开始时间-当前时间+3分钟大于33的话，每十秒语音提示一次
          this.isNotStartFlag = true;
          this.flagOver30 = true;
          this.minutesNotStart = this.minutes;
          this.secondsNotStart = this.seconds;
        }
        else { //如果距离结束时间小于30分钟
          this.flagOver30 = false;
          this.minutes = parseInt(leftTime / 60);
          this.seconds = parseInt(leftTime % 60);
          if (leftTime > 300) { //在竞价开始前前每10秒报一次价格
            this.minutesNotStart = this.minutes - 5;
            this.secondsNotStart = this.seconds;
            this.isNotStartFlag = true;
            if (this.seconds % 10 == 0) {
              var textspeak = "距离竞价开始剩余" + this.minutesNotStart + "分" + this.secondsNotStart + "秒";
              this.handleSpeak(textspeak);
            }
          }
          if (leftTime <= 300) //如果剩余时间为3分钟的话，提示报价开始
          {
            this.isNotStartFlag = false;
            this.handleSpeak("竞价已开始，请报价!");
            this.handleStop();
          }
          if (leftTime == 120) //如果剩余时间为3分钟的话，提示报价开始
          {
            this.isNotStartFlag = false;
           this.isYanShiFlag = true;
          }

          if (leftTime < 120 && leftTime > 0) { //如果距离结束时间大于0的话，
            // console.log(leftTime)
            //
             this.isNotStartFlag = false;
            this.isEndFlag = false;
             this.isYanShiFlag = true;
          }

          var endDate;
          var leftTime;//剩余时间

          if (leftTime <= 0) {
            this.isNotStartFlag = false;
             this.saveOver();
            clearInterval(this.timerFirst);


          }
        }
      },



      send() {

        if(this.ladderNumber==this.lastLadderNumber){
            this.$message.error("您必须加价一次才可竞价！")
            return;
        }
        this.biddingRecordDto.price = this.ladderNumber *  this.project.ladderPrice;
        if (this.topPrice != 0 && this.topPrice >= this.biddingRecordDto.price) {
          this.$message.error("您输入的报价小于当前最高报价，报价失败。")
          return null;
        }

        this.$confirm('您的出价为：' + this.biddingRecordDto.price + '请确认您的出价，确认后不可更改', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post("web/apiWebSocket/v1/sendOneWebSocket", this.biddingRecordDto).then((res) => {
            console.log(res)
            this.$message.success(res.data.msg);
             this.isYanShiFlag = false;
            if (res.data.msg == "success") {
              this.$message.success("出价成功!")
              this.handleSpeak("出价成功!");
              //this.chuJiaCount=this.chuJiaCount+1;
            }
          });
        }).catch(() => {
          //几点取消的提示
        });
      },
      async saveOver() {
        const {
          data: res
        } = await this.$http.get("/web/v1/bidingResult/" + this.projectId);
        //   this.$router.push("/enrollProjectAlready");
          if(res.code=="0"){
            this.handleSpeak("竞价已结束");
            this.back();
          }
        //
      },
      collapse: function() {
        this.isCollapse = !this.isCollapse;
        if (this.isCollapse) {
          this.iconClass = "cebianlanzhankai";
        } else {
          this.iconClass = "cebianlanshouhui";
        }
      },
      initWebSocket: function() {
        var keys = this.userId + "-" + this.projectId;
        this.websock = new WebSocket("ws://36.133.43.44:8547/api/web/websocket/" + keys);
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen: function() {
        console.log("WebSocket连接成功");
      },
      websocketonerror: function(e) {
       // console.log("WebSocket连接发生错误");
      },
      websocketonmessage: function(e) {
        console.log("消息到来了")
        var da = e.data;
        this.getPriceRecord();
      },
      websocketclose: function(e) {
        console.log("connection closed (" + e.code + ")");
      },
      handleSpeak(text) { //播放语音
        msg.text = text;
        msg.lang = 'zh-CN';
        msg.volume = '1';
        msg.rate = 1;
        msg.pitch = 1;
        synth.speak(msg);
      },
      // 语音停止
      handleStop(e) {
        msg.text = e;
        msg.lang = 'zh-CN';
        synth.cancel(msg);
      },
      back() {

        var that = this;
        setTimeout(function() {
          that.$router.go(-1); //返回上一层
        }, 5000);
      },
      operateTime (date, type, number) {
          /**
               * 时间加减
               * @param date - 时间格式支持yyyy-MM-dd HH:mm:ss | yyyy/MM/dd HH:mm:ss
               * @param type - 类型：h-小时加减 m-分钟加减 s-秒加减 mi-毫秒加减
               * @param number - 加减的数值，负数表示减
               * @return dateCalc - 加减后的时间，格式yyyy-MM-dd HH:mm:ss
               */

          var timestamp1  = Date.parse(new Date(date));
          if (isNaN(timestamp1)){//兼容IE,safari...
              date = date.replace(/-/ig,"/");
              timestamp1 = Date.parse(new Date(date));
          }
          var timestamp2;
          switch(type){
      	case "h":
                  timestamp2 = timestamp1 + number*60000*60;
      		break;
              case "m":
                  timestamp2 = timestamp1 + number*60000;
      		break;
      	case "s":
                  timestamp2 = timestamp1 + number*1000;
      		break;
      	case "mi":
                  timestamp2 = timestamp1 + number;
      		break;
          }
          var date = new Date(timestamp2);
          var Y = date.getFullYear() + '-';
          var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
          var D = (date.getDate()<10?'0'+date.getDate():date.getDate()) + ' ';
          var h = (date.getHours()<10?'0'+date.getHours():date.getHours()) + ':';
          var m = (date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes()) + ':';
          var s = date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds();
          return Y+M+D+h+m+s;
      },
    }
  }
</script>

<style lang="css" scoped="">
  .jingjia1 {
    width: 100%;
    height: 40px;
    margin-top: 5px;
  }

  .jingjia2 {
    width: 96%;
    height: 20px;
    line-height: 20px;
    margin-left: 2%;
  }

  .jingjiaInfo {
    width: 100%;
    height: 350px;
    margin-top: 20%;
  }

  .jingjiaInfo_left_leftContent {
    width: 30px;
    height: 120px;
    background-color: #3a4a7d;
    text-align: center;
    border-radius: 7px;
    float: left;
    margin-top: 100px
  }

  .jingjiaInfo_left_right {
    width: 80%;
    margin-left: 2%;
    margin-top: 60px;
    float: left;
    color: white;
  }

  .zuigaochujia {
    width: 60%;
    height: 40px;
    text-align: center;
    background-color: #f5a623;
    margin-left: 30%;
    margin-top: -55px;
    font-size: 18px;
    line-height: 40px;
    color: white;
    border-radius: 50px;
  }

  .zuigaojia {
    width: 60%;
    height: 200px;
    line-height: 200px;
    text-align: center;
    margin-left: 25%;
    margin-top: 0px;
    color: white;
  }

  .jingjiaInfo_right {
    width: 30%;
    margin-left: 1%;
    min-height: 170px;
    height: auto;
    overflow: hidden;
    margin-top: 10%;
    float: left;
    ;
    font-size: 16px;
    box-shadow: 7px 9px 8px #1d1419;
  }

  .center_left_top {
    width: 100%;
    height: 40px;
    border-radius: 5px;
    color: white;
    /* background-color: #ececec; */
  }

  .bottom_content_right {
    width: 23%;
    height: 100%;
    background-color: #2e698b;
    border-radius: 10px;
    float: left;
    margin-left: 2%;
    overflow-y: auto;
  }

  .bottom_content_center {
    width: 50%;
    height: 100%;
    background-color: #2e698b;
    border-radius: 10px;
    float: left;
    margin-left: 2%;
    float: left;
  }


  .allContent {
    width: 100%;
    height: 100vh;
    background-color: #3882ad;
  }

  .top_header {
    width: 96%;
    margin-left: 2%;
    height: 5%;
    line-height: 5vh;
    color: white;
    font-size: 28px
  }

  .bottom_content {
    width: 96%;
    height: 92%;
    margin-top: 1vh;
    margin-left: 2%;
  }

  .bottom_content_left {
    width: 23%;
    height: 100%;
    background-color: #2e698b;
    border-radius: 10px;
    float: left;
  }

  .bottom_content_left_top {
    width: 96%;

    margin-left: 2%;
    background-color: #27b0ff;
    border-radius: 10px;
    text-align: center;
    font-size: 20px;
    color: white;
    vertical-align: middle;
    height: 60px;
    line-height: 60px
  }

  .bottom_content_left_bottom {
    width: 96%;
    height: 90%;
    margin-left: 2%;
    margin-top: 2%;
  }

  .bottom_content_left_bottom_per {
    width: 96%;
    margin-left: 2%;
    height: 9%;
    color: white;
    font-size: 18px;
    margin-top: 2%;
    line-height: 100px;
    vertical-align: middle;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

  }



  .inputPriceName {
    width: 15%;
    height: 60px;
    line-height: 60px;
    text-align: right;
    float: left;
  }

  .inputPriceContent {
    width: 83%;
    height: 80px;
    line-height: 80px;
    text-align: right;
    float: left;
  }

  .priceSend {

    width: 8%;
    height: 80px;
    float: left;
    line-height: 80px;
    text-align: left;
  }

  .center_right_top {
    height: 40px;
    width: 100%;
  }

  .center_right_per {
    height: 40px;
    line-height: 40px;
    text-align: center;
    width: 33%;
    float: left;
    color: white;
  }


  .projectName {
    height: 60px;
    font-size: 24px;
    text-align: center;
  }

  .content_left {
    border-radius: 10px;
    box-shadow: 7px 9px 8px #c2c2c2;
    min-height: 600px;
    font-size: 22px;
    text-align: center;
    border: 1px solid #ccc;
  }
</style>
